import { z } from 'zod';
/**
 * My Calendar (FR-CAL-01/02): an aggregate over things with a time — scheduled
 * posts/polls/fundraisers, events (attending or hosting), debates (deferred).
 * Calendly (FR-CAL-04, Q-08) is a deep link stored on the profile.
 */
export const CalendarItemKind = z.enum([
    'scheduled_post',
    'scheduled_poll',
    'scheduled_fundraiser',
    'event_hosting',
    'event_attending',
    'group_meeting',
    'debate',
]);
export const CalendarItem = z.object({
    kind: CalendarItemKind,
    referenceId: z.string(),
    title: z.string(),
    startsAt: z.coerce.date(),
    endsAt: z.coerce.date().nullable(),
    /** IANA zone the item was authored in — displayed as-is, never device-local (NFR-15). */
    timezone: z.string().nullable(),
});
export const CalendarQuery = z.object({
    from: z.coerce.date(),
    to: z.coerce.date(),
});
export const CalendlyLinkInput = z.object({
    url: z
        .string()
        .url()
        .regex(/^https:\/\/calendly\.com\//, 'Must be a calendly.com link'),
});
//# sourceMappingURL=calendar.js.map